var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardCustomizeWhite24Dp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    height: "24px",
    viewBox: "0 0 24 24",
    width: "24px",
    fill: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,0h24v24H0V0z",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,11h8V3H3V11z M5,5h4v4H5V5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,3v8h8V3H13z M19,9h-4V5h4V9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,21h8v-8H3V21z M5,15h4v4H5V15z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18,13 16,13 16,16 13,16 13,18 16,18 16,21 18,21 18,18 21,18 21,16 18,16"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCustomizeWhite24Dp);
export default __webpack_public_path__ + "static/media/dashboard_customize_white_24dp.5ad1c1b0.svg";
export { ForwardRef as ReactComponent };